export default function HelpInfo() {
  return (
    <section className="mini-container  md:!max-w-[1000px] mt-10">
      <div className="p-8 bg-[#F5F9F9] rounded-[10px]">
        <h2 className="text-center text-theme-neutral-800 text-2xl font-semibold leading-9">
          আপনার কোনো প্রশ্ন বা সহায়তা দরকার?
        </h2>
        <div className="text-center text-theme-neutral-800 text-base font-normal leading-7 my-4">
          নিচের যেকোনো মাধ্যমে আমাদের সাথে যোগাযোগ করুন। আমরা দ্রুত আপনার পাশে
          থাকবো।
        </div>

        <div className="text-center text-theme-neutral-800 text-base font-normal">
          ইমেইল:{" "}
          <a
            className="text-theme-primary hover:text-theme-primary/80 transition-all duration-300"
            href="mailto:manpowerx.org@gmail.com"
          >
            manpowerx.org@gmail.com
          </a>
          <span className="mx-2">|</span>
          ফোন:{" "}
          <a
            className="text-theme-primary hover:text-theme-primary/80 transition-all duration-300"
            href="tel:0161190323"
          >
            ০১৬১১-০৯০৩২৩
          </a>
        </div>
      </div>
    </section>
  );
}
